const computeColor = (text = '') => {
  const colors = [
    // '#FFA07A', // Light Salmon
    // '#98FB98', // Pale Green
    // '#DDA0DD', // Plum
    // '#87CEFA', // Light Sky Blue
    // '#F0E68C', // Khaki
    // '#E6A8D7', // Light Orchid
    // '#FFB347' // Pastel Orange,

    '#f9d5de', // red
    '#f9ead5', // orange
    '#e7d5f9', // purple
    '#d5f9da' // green
  ];

  if (!text) {
    return colors[0]; // Default to the first color if text is empty or undefined
  }

  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (hash << 5) - hash + text.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }

  const colorIndex = Math.abs(hash) % colors.length;
  return colors[colorIndex];
};

const getFirstCharacter = (text = '') => text.charAt(0).toUpperCase();

const Avatar = ({ className, size = 'md', zIndex, id, name, email, isCurrent, overrideBackgroundColor, overrideContent, title }) => {
  const computedColor = isCurrent ? '#bccfdd' : computeColor(id || name || email || '');
  const computedTitle = title || (isCurrent ? 'You' : `${name}${email ? ` (${email})` : ''}`);
  const computedContent = getFirstCharacter(name || email || '');

  return (
    <div className={`comp-avatar ${className} ${size}`} style={{ backgroundColor: overrideBackgroundColor || computedColor, zIndex }} data-title={computedTitle}>
      <div>{overrideContent || computedContent}</div>
    </div>
  );
};

export default Avatar;
